import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TrophyIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/_jsx("path", {
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/_jsx("path", {
    d: "M11,14v5H7a1,1,0,0,0,0,2H17a1,1,0,0,0,0-2H13V14Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M6,3v8a6,6,0,0,0,12,0V3Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M20,5V8a3,3,0,0,1-3,3H7A3,3,0,0,1,4,8V5H20m0-2H4A2,2,0,0,0,2,5V8a5,5,0,0,0,5,5H17a5,5,0,0,0,5-5V5a2,2,0,0,0-2-2Z"
  })]
}), 'TrophyIcon');